import { render } from "./AlertItem.vue?vue&type=template&id=1b20ed6b&scoped=true"
import script from "./AlertItem.vue?vue&type=script&lang=js"
export * from "./AlertItem.vue?vue&type=script&lang=js"

import "./AlertItem.vue?vue&type=style&index=0&id=1b20ed6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b20ed6b"]])

export default __exports__